import { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";
import { transformOrgsToTable } from "./adminHelpers";
import {
  getOrgDataById,
  getUserDataById,
  queryCollection,
} from "../../models/DataFunctions";
import DataGridGPT2 from "../../tables/DataGridGPT2";
import { EasySwitch } from "../../textfields/EasySwitch";
import DropDownGPT03 from "../../dropdown/DropDownGTP03";
import TFGPT1 from "../../textfields/TFGPT1";
import Icon1 from "../../assets/icons/Icon";
import { Space } from "antd";

function Orgs({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();
  const [ca, setCa] = useState(0);
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const [remove_fake, setRemoveFake] = useState(true);
  const [searchValue, setSearchValue] = useState(null);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);
  const [filter_type, setFilterType] = useState("master");

  const [orgs, setOrgs] = useState([]);
  // Function to navigate to a client by ID
  const gotoOrg = (org) => {
    navigateWorkspace(`/admin/org/${org.id}`);
  };

  // Function to navigate to a client by name
  const gotoOrgEmail = (value) => {
    if (!value) return;
    // Find the client with the matching name
    const org = orgs.find((row) => row.email === value.value);

    // If client exists, navigate to the client page by ID
    if (org) {
      navigateWorkspace(`/admin/org/${org.id}`);
    } else {
      console.error("Org not found");
    }
  };

  useEffect(() => {
    let filteredOrgs = orgs.filter((org) => {
      if (remove_fake) {
        return org.facturation?.fake_account !== true;
      }
      return true;
    });

    const { rows, columns } = transformOrgsToTable(filteredOrgs);
    setRows(rows);
    setColumns(columns);
  }, [orgs, filter_type, remove_fake]);

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserDataById(currentUser.uid);

      // Fetch organization data using the user's org reference
      const org = await getOrgDataById(user.org_id);

      // Fetch clients associated with the user's organization
      const orgs = await queryCollection("org", []);

      // Transform clients into table format (rows and columns)
      const { rows, columns } = transformOrgsToTable(orgs);

      // Update state if the user data is new or changed
      if (user && user !== userData) {
        setUserData(user);
        setOrgData(org);
        setOrgs(orgs);
        setRows(rows);
        setColumns(columns);

        // Set options for the search bar (client names)
        setOptions(
          orgs.map((org) => ({
            value: org.email,
            label: org.email + " - " + org.name,
          }))
        );
      }
    }
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser, filter_type]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  // Render the client data
  return (
    <div className="flex flex-col h-full w-full pl-4 pt-4 ">
      <div className="flex flex-row w-full h-full">
        <div className="flex flex-col gap-2 h-full w-full ">
          <div className="text-hx font-medium">Organisations</div>
          <div className="bg-white border-1 border-shadow_25 rounded-full max-w-c500 flex flex-row gap-2 items-center px-2">
            <Icon1 icon_name="search" size={20} fill="grey"></Icon1>
            <TFGPT1
              options={options}
              placeholder="Chercher"
              inputValue={searchValue}
              setInputValue={setSearchValue}
              onAction={gotoOrgEmail}
              className="w-full"
              start_only={false}
            ></TFGPT1>
          </div>{" "}
          {/* DataGrid displaying the clients */}
          <div className="w-full h-full max-h-[60%]  max-w-full mt-2">
            <DataGridGPT2
              rows={rows}
              columns={columns}
              onClick={gotoOrg}
              initial_sort_field="creation"
              initial_saved_columns_showed={{
                ref: false,
              }}
              initial_asc="desc"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Orgs;
